<app-form-question-container [name]="name" [questionId]="questionId" [tooltip]="tooltip">
  <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group" [disabled]="disabled" [(ngModel)]="answer">
    @for (possibleAnswer of possibleAnswers; track possibleAnswer) {
      <mat-radio-button
        [attr.data-answer-id]="possibleAnswer.Id"
        class="example-radio-button"
        (change)="onOptionChange($event)"
        [value]="possibleAnswer"
        [disabled]="isDisabled || possibleAnswer.IsObsolete"
        >
        {{ possibleAnswer.Name }}
      </mat-radio-button>
    }
  </mat-radio-group>
</app-form-question-container>